"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  primary: '#fc3a52',
  secondary: '#f9b248',
  tertiary: '#e8d5b7'
};
exports.colors = colors;